// extracted by mini-css-extract-plugin
export var circle = "_2p-2";
export var icon = "_2p-a";
export var iconHighlight = "_2p-0";
export var lg = "_2p-8";
export var md = "_2p-7";
export var outline = "_2p-4";
export var sm = "_2p-6";
export var square = "_2p-1";
export var xl = "_2p-9";
export var xs = "_2p-5";
export var xxs = "_2p-3";